import Icon from '@/assets/icons/topic.svg';
import { ClientAuth, Device, Logger } from '@/classes';
import { useRouter } from '@/hooks/useRouter';
import { ContentGroupList } from '@/widgets/content-group-list';
import { Menu } from '@/widgets/menu';
import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const TopicsPage = () => {
  const router = useRouter();
  const { t } = useTranslation();

  const header = useMemo(
    () => (
      <>
        <img src={Icon} />
        <h1 className={`ml-3 text-[55px] text-[#000000] ${Device.language !== 'zh' && 'font-bold'}`}>
          {t('menu_topics')}
        </h1>
      </>
    ),
    [t],
  );

  useEffect(() => {
    if (!ClientAuth.user) {
      router.push('/login', { replace: true });
    }
  }, [router]);

  useEffect(() => {
    Logger.homeTopic();
  }, []);

  return (
    <div className="flex flex-col lg:flex-row h-screen">
      <Menu />
      <div className="flex flex-1 overflow-hidden">
        <ContentGroupList
          containerClassName="w-full h-screen overflow-x-hidden overflow-y-auto bg-[#FFFDF1]"
          headerClassName="pl-[52px] py-[16px] fixed flex items-center font-babyshark z-40 w-full bg-[#FFFDF1]"
          header={header}
        />
      </div>
    </div>
  );
};
